"use client";

import { useState } from "react";

/**
 * Hook for managing the signup form state (email, password, auth method, loading states).
 */
export function useSignupForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [authMethod, setAuthMethod] = useState<"magic-link" | "password">("password");
  const [isLoading, setIsLoading] = useState(false);
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [isResending, setIsResending] = useState(false);

  const isEmailValid = email.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const hasEmailError = email.length > 0 && !isEmailValid;

  const isPasswordValid =
    password.length >= 8 && !password.startsWith(" ") && !password.endsWith(" ");
  const hasPasswordError = password.length > 0 && !isPasswordValid;

  return {
    email,
    setEmail,
    password,
    setPassword,
    showPassword,
    setShowPassword,
    authMethod,
    setAuthMethod,
    isLoading,
    setIsLoading,
    magicLinkSent,
    setMagicLinkSent,
    isResending,
    setIsResending,
    isEmailValid,
    hasEmailError,
    isPasswordValid,
    hasPasswordError,
  };
}
